import { configureAccountsApi } from '@wiser/auth';

// WiserWeb single-account login toggle (frontend half). Set VITE_WISER_ACCOUNTS_URL to enable; it must
// match the backend (which must expose POST /api/auth/wiser to trade the wiser-accounts session for a
// native WiserWeb AI JWT). When unset, the app keeps its bespoke email/password form verbatim.
export const WISER_ACCOUNTS_URL = import.meta.env.VITE_WISER_ACCOUNTS_URL as string | undefined;
export const wiserAccountsEnabled = Boolean(WISER_ACCOUNTS_URL);

if (wiserAccountsEnabled) {
  configureAccountsApi({ baseUrl: WISER_ACCOUNTS_URL! });
}

// Where to send an authenticated user who has no plan/entitlement for this app. Pilot: no gating yet, but
// the seam is wired so a future shared plan service can redirect here.
export const WISER_ONBOARD_URL =
  (import.meta.env.VITE_WISER_ONBOARD_URL as string | undefined) || '/pricing';

// Invite code for signup (wiser-accounts is invite-gated). Preset for the pilot; real deployments would
// collect it from the user or drive signup elsewhere.
export const WISER_INVITE_CODE = import.meta.env.VITE_WISER_INVITE_CODE as string | undefined;
